<div
	class="flex gap-2 h-10 items-center select-none overflow-hidden px-4 hover:bg-primary-200 cursor-pointer"
	[class]="{
		'bg-primary-100': selected(),
		'text-secondary-400': option().isDisabled,
		'cursor-not-allowed!': option().isDisabled,
		'hover:bg-white': option().isDisabled,
		'pl-9': !option().isDisabled && unionSelected(),
	}"
	(click)="toggleItemHandler(option())"
	(keydown.enter)="toggleItemHandler(option())"
	(keydown.space)="toggleItemHandler(option())"
	data-cy="c-vehicle-union-select-select-option"
>
	<ui-checkbox
		[disabled]="option().isDisabled || false"
		[checked]="selected()"
		class="mr-4"
		(click)="onCheckboxClick($event)"
	></ui-checkbox>
	<div class="flex items-center justify-between -ml-4 w-full gap-2 min-w-0">
		<div class="flex items-center gap-1 max-w-full min-w-0 flex-1">
			@if (isSubscriptionExpiringSoon(option().value)) {
				<ui-icon
					icon="failures"
					[uiTooltip]="'general.subscription_almost_expired_tooltip' | translate"
					class="flex-shrink-0"
				></ui-icon>
			}
			@if (isSubscriptionExpired(option().value)) {
				<ui-icon
					icon="problem"
					[uiTooltip]="'general.subscription_expired_tooltip' | translate"
					class="flex-shrink-0"
				></ui-icon>
			}

			<div class="flex whitespace-nowrap max-w-full min-w-0 overflow-hidden">
				<div
					class="max-w-full flex items-center gap-1"
					[uiTooltip]="option().isDisabled ? '' : (option().value | vehicleOptionTooltip)"
				>
					<span class="truncate">{{ option().value?.name }}</span>
					<span
						class="text-xs flex-shrink-0"
						[attr.data-cy]="'vehicle-select-option-serial-' + option().value?.serial"
						>({{ option().value?.serial }})</span
					>
					@if (!shouldHideUnion() || (!shouldHideCustomer() && role() !== Role.customer)) {
						<span class="flex-shrink-0"> | </span>
					}
				</div>
				@if (!shouldHideUnion()) {
					<div
						class="sm:flex-shrink-0 overflow-hidden text-ellipsis"
						[class]="{
							'text-secondary-400': option().isDisabled,
							'text-primary-900': !option().isDisabled,
						}"
						[uiTooltip]="option().isDisabled ? '' : ('general.select_whole_union' | translate)"
						(click)="onSelectWholeUnion(option(), $event)"
					>
						{{ option().value?.union | empty }}
					</div>
				}

				@if (!shouldHideCustomer() && role() !== Role.customer) {
					<div
						class="md:block line-clamp-1 text-ellipsis min-w-0"
						[uiTooltip]="option().isDisabled ? '' : (option().value | vehicleOptionTooltip)"
					>
						| {{ option().value?.customer }}
					</div>
				}
			</div>
		</div>
		@if (displayPills()) {
			<div class="flex gap-1 flex-shrink-0">
				@if (option().value?.maas) {
					<ui-pill [value]="'general.maas' | translate"></ui-pill>
				}

				@let subscriptionRemaining = getSubscriptionRemaining(option().value?.subscription_end);

				@if (subscriptionRemaining <= 0) {
					<ui-pill [value]="'subscription.expired' | translate"></ui-pill>
				} @else {
					<ui-pill
						[value]="
							subscriptionRemaining
								| pluralTranslate
									: 'subscription.remaining_day'
									: 'subscription.remaining_days'
									: { remaining: subscriptionRemaining }
						"
						type="secondaryOutline"
					></ui-pill>
				}
			</div>
		}

		@if (displayVehicleModel() && !displayPills()) {
			<div class="flex gap-1 flex-shrink-0">
				<ui-pill
					[value]="option().value?.machine_model || option().value?.model"
					type="secondaryOutline"
				></ui-pill>
			</div>
		}
	</div>
</div>
